import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as paymentApi from '../../shared/services/payment/paymentApi';

const initialState = {
  settings: null,
  isLoading: false,
  error: null,
  isUpdating: false,
  isTestingConnection: false,
};

// Async thunks
export const fetchPaymentSettings = createAsyncThunk(
  'payment/fetchPaymentSettings',
  async (_, { rejectWithValue }) => {
    try {
      const data = await paymentApi.getPaymentSettings();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const updatePaymentSettings = createAsyncThunk(
  'payment/updatePaymentSettings',
  async (updates, { rejectWithValue }) => {
    try {
      const data = await paymentApi.updatePaymentSettings(updates);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const testRozetkaPayConnection = createAsyncThunk(
  'payment/testRozetkaPayConnection',
  async (_, { rejectWithValue }) => {
    try {
      const data = await paymentApi.testRozetkaPayConnection();
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    resetUpdateStatus: (state) => {
      state.isUpdating = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch payment settings
      .addCase(fetchPaymentSettings.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPaymentSettings.fulfilled, (state, action) => {
        state.isLoading = false;
        state.settings = action.payload.settings;
      })
      .addCase(fetchPaymentSettings.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      
      // Update payment settings
      .addCase(updatePaymentSettings.pending, (state) => {
        state.isUpdating = true;
        state.error = null;
      })
      .addCase(updatePaymentSettings.fulfilled, (state, action) => {
        state.isUpdating = false;
        state.settings = action.payload.settings;
      })
      .addCase(updatePaymentSettings.rejected, (state, action) => {
        state.isUpdating = false;
        state.error = action.payload;
      })
      
      // Test RozetkaPay connection
      .addCase(testRozetkaPayConnection.pending, (state) => {
        state.isTestingConnection = true;
        state.error = null;
      })
      .addCase(testRozetkaPayConnection.fulfilled, (state) => {
        state.isTestingConnection = false;
      })
      .addCase(testRozetkaPayConnection.rejected, (state, action) => {
        state.isTestingConnection = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, resetUpdateStatus } = paymentSlice.actions;
export default paymentSlice.reducer;
